<template>
  <div
  class="FileSquare">
    <el-checkbox
      class="FileSquare__checkbox"
      :class="{ 'FileSquare__checkbox--active': checked}"
      v-model="checked"/>
    <img
      @click="handleSelect(file)"
      class="FileSquare__thumbnail"
      :title="file.name"
      :src="file.thumbnailUrl || thumbnailPlaceholder(file.type)"
      :style="{ 'background-image': 'url('+thumbnailPlaceholder(file.type)+')'}"/>
    <div
    v-if="showBar"
    class="FileSquare__bar">
      <i
      class="FileSquare__icon"
      :style="{ 'background-image': 'url('+iconPath+')'}"/>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import FileMixin from '@/components/mixins/File.mixin'

export default {
  name: 'FileSquare',

  mixins: [
    FileMixin
  ],

  props: {
    file: {
      type: Object,
      required: true,
      validator (file) {
        return file.id && file.name && !Number.isNaN(file.type)
      }
    }
  },

  computed: {
    ...mapGetters('select', [
      'checkedById'
    ]),
    checked: {
      get () {
        return !!this.checkedById(this.file.id)
      },
      set (value) {
        this.setChecked({ id: this.file.id, file: this.file, value })
      }
    },
    showBar () {
      return this.file.type === 2
    },
    iconPath () {
      let path = '/images/icon-'
      switch (this.file.type) {
        case 2:
          path += 'video-white.png'
          break
        default:
          path += 'video-white.png'
          break
      }
      return path
    }
  },

  beforeUpdate () {
    this.hidePreview()
  },

  beforeDestroy () {
    if (this.checked) {
      this.setChecked({ id: this.file.id, value: false })
    }
  },

  methods: {
    ...mapActions('select', [
      'setChecked'
    ])
  }
}
</script>

<style lang="scss">
@import 'FileSquare';
</style>
